import React from "react";

type StatusType = "success" | "info" | "warning" | "error";

interface StatusCardProps {
  status: StatusType;
  children: React.ReactNode;
  className?: string;
}

const statusConfig = {
  success: {
    bgColor: "bg-green-50 dark:bg-green-900/50",
    badgeColor: "bg-green-600",
    badgeText: "Success",
  },
  info: {
    bgColor: "bg-blue-50 dark:bg-blue-900/20",
    badgeColor: "bg-blue-600",
    badgeText: "Connection Successful",
  },
  warning: {
    bgColor: "bg-yellow-50 dark:bg-yellow-900/20",
    badgeColor: "bg-yellow-600",
    badgeText: "Warning",
  },
  error: {
    bgColor: "bg-red-50 dark:bg-red-900/20",
    badgeColor: "bg-red-600",
    badgeText: "Error",
  },
};

export function StatusCard({
  status,
  children,
  className = "",
}: StatusCardProps) {
  const config = statusConfig[status];

  return (
    <div className={`${config.bgColor} rounded-xl p-5 space-y-3 ${className}`}>
      <div
        className={`inline-flex items-center gap-1 ${config.badgeColor} text-white px-2.5 py-0.5 rounded-full text-sm font-semibold`}
      >
        <div className="w-1 h-1 bg-white rounded-full"></div>
        {config.badgeText}
      </div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}
